import { z } from 'zod';

export const ProfileTemplateScopeTypeSchema = z.enum(['TENANT', 'PLACE']);

export type ProfileTemplateScopeType = z.infer<typeof ProfileTemplateScopeTypeSchema>;

export const ProfileTemplateIdParamsSchema = z.object({
  profileTemplateId: z.uuid(),
});

export type ProfileTemplateIdParams = z.infer<typeof ProfileTemplateIdParamsSchema>;

export const ProfileTemplatePermissionSchema = z.object({
  id: z.uuid(),
  slug: z.string(),
  description: z.string().nullable(),
});

export type ProfileTemplatePermission = z.infer<typeof ProfileTemplatePermissionSchema>;

export interface PermissionCatalogNode {
  id: string;
  slug: string;
  parentId: string | null;
  description: string | null;
  assignable: boolean;
  children: PermissionCatalogNode[];
}

export const PermissionCatalogNodeFieldsSchema = z.object({
  id: z.uuid(),
  slug: z.string(),
  parentId: z.uuid().nullable(),
  description: z.string().nullable(),
  assignable: z.boolean(),
});

/** Runtime tree validation — recursive (`z.lazy` breaks zod-to-openapi; use OpenAPI schema in paths). */
export const PermissionCatalogNodeSchema: z.ZodType<PermissionCatalogNode> = z.lazy(() =>
  PermissionCatalogNodeFieldsSchema.extend({
    children: z.array(PermissionCatalogNodeSchema),
  }),
);
